import type { FaireProductEntity } from "../../entity_types/product";

export const p_j349sdjkfh: FaireProductEntity = {
  token: "p_j349sdjkfh",
  type: "product",
  name: "Mango Shampoo Bars x 2 | Organic, Eco-friendly, Plastic-free",
  brandToken: "b_v44qpcjjza",
  brandName: "Lyness",
  imageUrl:
    "https://cdn.faire.com/fastly/352da0678940706cd8b0308836fea86be941a60b065339d2a74c6489c3d04298.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1efae0d4be163cf0516ade61aa167506514ad05ceffc8a841c94798a5efe7f31.png",
    "https://cdn.faire.com/fastly/cd65881c1e63f43929811cb99f0ed47f2e4801992547bf657695a37266912a86.png",
    "https://cdn.faire.com/fastly/7c3c239684c351d3583856feffd42e8e7a5f2c91bae7167323e665dd3128e0cd.png",
    "https://cdn.faire.com/fastly/8afd8484514f3d560df4ffb5c8a2bda430d8994936b07d808edef692435fa472.png",
    "https://cdn.faire.com/fastly/1011112588c9681eaddcd6d2013cdbbdaa79bf8ac1a161b5f259c15f26f5ba9f.png",
    "https://cdn.faire.com/fastly/ff89c99e361398b85efc40163ba3c24b5d0d29491ebc7ec6ec070c2c2eb1694b.png",
    "https://cdn.faire.com/fastly/afc9fd44593bef180aa5bda8e1c7bc81b87fd536da824284d2c6bafc65e5403e.png",
    "https://cdn.faire.com/fastly/bdc3028d1488ccf9763667401a0d3a053089e1270b64107c4edf6f732672eb25.png",
  ],
  priceDollars: 20.99,
  description:
    "Bring strength, volume, and moisture back to your hair with the nourishing power of mango. This rich, tropical bar helps fortify each strand while enhancing natural fullness and softness.\n\n * Gentle Coconut Cleanse: Sodium Coco Sulfate, derived from coconuts, creates a creamy, luxurious lather that cleans effectively without the harshness of SLS. \n * Strength & Volume: Organic Cocoa Butter deeply conditions while helping reinforce the hair shaft for stronger, fuller-looking strands. \n * Hydration & Smoothness: Virgin Olive Oil delivers lasting moisture, helping to repair dryness and reduce frizz for soft, manageable hair. \n * Mango Essential Oil: Infuses the scalp and hair with rich hydration, supporting strength and flexibility while promoting a naturally healthy bounce and vibrant shine. \n * Eco-Friendly & Long-Lasting: Each concentrated bar lasts as long as three bottles of liquid shampoo and comes in a reusable aluminium tin, perfect for home or travel. ",
  tags: [],
  msrpDollars: 34.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:02:08.365Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
